import { all, takeLatest, call, put } from 'redux-saga/effects';

import * as apis from '@coconut/services/apis/cancelQuestion';

import {
  types,
  chatCancelQuestionSuccess,
  chatCancelQuestionFailed,
} from '../redux/cancelQuestion';
import { appendMessage } from '../redux/chatsMessage';
import { updateSelectQuestion } from '../redux/selectQuestion';
import { home } from '@coconut/services/redux/navigation';
import { getCapitalizedRegionLang } from '@coconut/utils/langParser';

export function* cancelQuestionFlow(action) {
  const { userID, QID, lang } = action.payload;

  try {
    const response = yield call(apis.cancelQuestion, {
      lang: getCapitalizedRegionLang(lang),
      userId: userID,
      questionId: QID,
    });

    const {
      data: { message, question },
    } = response;

    // append cancel message to current message stack.
    yield put(appendMessage(message));

    // update selected question.
    yield put(updateSelectQuestion(question));

    yield put(chatCancelQuestionSuccess());

    yield put(home());
  } catch (err) {
    yield put(chatCancelQuestionFailed(err.message));
  }
}

export default function* () {
  yield all([takeLatest(types.CHAT_CANCEL_QUESTION, cancelQuestionFlow)]);
}



// WEBPACK FOOTER //
// ./src/scenes/Chat/services/sagas/cancelQuestion.js